import { useApolloClient } from "@apollo/client";
import { Button, Grid } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import React, { useEffect } from "react";
import { ToastContainer } from "react-toastify";
import { useRecoilState, useRecoilValue, useResetRecoilState } from "recoil";
import {
  valueInputJobDescAtoms,
  valueInputJobRequirementAtoms,
  valueInputOpportunity
} from "../../../../shared/atoms/getValueInputAtoms";
import FormDetail from "./FormDetail";

function ModalDetailOpportunity(props) {
  const { isOpen, onClose, dataDetail, fecthOpportunity, setDataDetailJob } =
    props;
  const { title, division_id, description, location_id, job_level } =
    useRecoilValue(valueInputOpportunity);
  const client = useApolloClient();

  const resetInputOpportunity = useResetRecoilState(valueInputOpportunity);
  const resetInputJobDesc = useResetRecoilState(valueInputJobDescAtoms);
  const resetInputRequirement = useResetRecoilState(
    valueInputJobRequirementAtoms
  );
  const [_, setInputOpportunity] = useRecoilState(
    valueInputOpportunity
  );

  const handlePopulateValue = () => {
    setInputOpportunity({
      title: dataDetail.title,
      location_id: dataDetail.location_id,
      description: dataDetail.description,
      division_id: dataDetail.division_id,
      job_level: dataDetail.job_level,
    });
  };

  useEffect(() => {
    handlePopulateValue();
  }, [isOpen]);


  // const submitUpdateOpportunity = async () => {
  //   const inputOpportunity = {
  //     id: dataDetail.id,
  //     title: title,
  //     description: description,
  //     location_id: location_id,
  //     division_id: division_id,
  //     job_level: job_level,
  //   };

  //   if (
  //     title === "" ||
  //     title === null ||
  //     description === "" ||
  //     description === null ||
  //     location_id === "" ||
  //     location_id === null ||
  //     division_id === "" ||
  //     division_id === null ||
  //     job_level === "" ||
  //     job_level === null
  //   ) {
  //     return setErrInput(true);
  //   }
  //   try {
  //     const response = await UpdateOpportunity(client, inputOpportunity);
  //     if (response.data.updateOpportunity.errMsg === "OK") {
  //       toast.success("Jobs Updated", {
  //         position: toast.POSITION.TOP_RIGHT,
  //       });
  //       resetInputOpportunity();
  //       resetInputJobDesc();
  //       resetInputRequirement();
  //       onClose();
  //       fecthOpportunity();
  //     } else {
  //       toast.error("Error Update", {
  //         position: toast.POSITION.TOP_RIGHT,
  //       });
  //     }
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };
  return (
    <React.Fragment>
      <ToastContainer />
      <Dialog
        open={isOpen}
        onClose={onClose}
        fullWidth
        sx={{ mt: 1 }}
        maxWidth="xl"
      >
        <Grid container>
          <Grid item>
            <DialogTitle>Detail Job</DialogTitle>
          </Grid>
        </Grid>
        <DialogContent>
          <FormDetail
            detailJob={dataDetail}
            fecthOpportunity={fecthOpportunity}
            setDataDetailJob={setDataDetailJob}
            isOpen={isOpen}
            onClose={onClose}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose} variant="outlined" color="error">
            Close
          </Button>{" "}
          {/* <Button
            variant="contained"
            onClick={() => submitUpdateOpportunity()}
            color="primary"
            type="submit"
          >
            Submit Update
          </Button> */}
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}

export default ModalDetailOpportunity;
